export default [
  {
    Name: "Pradeep Kumar",
    Img: "/assets/pradeep.jpeg",
    Post: "Vehical Health Management Intern",
    Company: "General Motors, Michigan, USA",
    linkedinurl: "https://www.linkedin.com/in/pradeep-kumar-zhcet/",
  },
  {
    Name: "Rehan Abad Siddiqui",
    Img: "/assets/rehan.png",
    Company: "L&T",
    linkedinurl: "https://www.linkedin.com/in/rehan-abad-siddiqui/",
  },
  {
    Name: "Kamran Shakir",
    Img: "/assets/kamran.png",
    Company: "EPFL",
    linkedinurl: "https://www.linkedin.com/in/kamran-shakir/",
  },
  {
    Name: "Md Zeeshan Uddin",
    Img: "/assets/zeeshan.jpeg",
    Post: "Assistant Manager",
    Company: "CEAT Limited",
    linkedinurl: "https://www.linkedin.com/in/md-zeeshan-uddin-266807150/",
  },
  {
    Name: "Prashant Vardhan Singh",
    Img: "/assets/prashant.jpeg",
    Post: "System Engineer",
    Company: "TCS",
    linkedinurl:
      "https://www.linkedin.com/in/prashant-vardhan-singh-a97619139/",
  },
  {
    Name: "Faraz Ahmad",
    Img: "/assets/faraz_ahmad.png",
    Company: "Micron Technology",
    linkedinurl: "https://www.linkedin.com/in/faraz-ahmad/",
  },
  {
    Name: "Aman Agarwal ",
    Img: "/assets/aman.jpeg",
    Post: "Senior Product Marketing Specialist",
    Company: "Drawinbox",
    linkedinurl: "https://www.linkedin.com/in/amanagarwal95/",
  },
  {
    Name: "Shadman Faraz",
    Img: "/assets/shadman.png",
    Company: "Qualcomm",
    linkedinurl: "https://www.linkedin.com/in/shadmanf/",
  },
  {
    Name: "Asim Noor",
    Img: "/assets/asim.png",
    Company: "Central Mechanical Engineering Research Institute",
    linkedinurl: "https://www.linkedin.com/in/noorasim/",
  },
  {
    Name: "Hamzah Khan",
    Img: "/assets/hamzah.jpeg",
    Post: "Head of DeFi and Labs",
    Company: "Polygon Technology",
    linkedinurl: "https://www.linkedin.com/in/hamzahkhan1/",
  },
  {
    Name: "Nafees Ahmad",
    Img: "/assets/nafees_ahmad.png",
    Company: "Eltech Appliances",
    linkedinurl: "https://www.linkedin.com/in/nafeesahd/",
  },
  {
    Name: "Syed Kashif Zafar",
    Img: "/assets/kashif.jpeg",
    Post: "Software Design Engineer",
    Company: "Alstom",
    linkedinurl: "https://www.linkedin.com/in/skashifzafar/",
  },
  {
    Name: "Mohammad Atif Qazi",
    Img: "/assets/atif.png",
    Company: "U. Alberta",
    linkedinurl: "https://www.linkedin.com/in/aatifqazi/",
  },
  {
    Name: "Mohammad Faraz",
    Img: "/assets/faraz.jpeg",
    Post: "Software Developer",
    Company: "ETAS",
    linkedinurl: "https://www.linkedin.com/in/faraz-rwth/",
  },
  {
    Name: "Owais Ahmed Khan",
    Img: "/assets/owais.jpeg",
    Post: "Lead Test Developer",
    Company: "Magna International",
    linkedinurl: "https://www.linkedin.com/in/owais-ahmed-khan-30a031108/",
  },
  {
    Name: "Shubham Varshney",
    Img: "/assets/shubham.jpeg",
    Post: "Memory Design Engineer",
    Company: "STMicroelectronics",
    linkedinurl: "https://www.linkedin.com/in/shvarshney/",
  },
  {
    Name: "Mohammad Suboor Aziz",
    Company: "University Canada West(UCW)",
  },
  {
    Name: "Faizan Anwar",
    Company: "JUSPAY",
  },
  {
    Name: "Mohammad Afzal Shadab",
    Img: "/assets/afzal.png",
    Post: "NASA Jet Propulsion Lab Graduate Fellow",
    Company: "NASA",
    linkedinurl: "https://www.linkedin.com/in/mashadab/",
  },
  {
    Name: "Shubham Jain",
    Img: "/assets/shubham_jain.png",
    Company: "L&T",
    linkedinurl: "https://www.linkedin.com/in/shubham-jain-891726144/",
  },
  {
    Name: "Qazi Mohd Taha",
    Img: "/assets/qazi.jpeg",
    Post: "Digital Marketing Intern",
    Company: "Bright Money",
    linkedinurl: "https://www.linkedin.com/in/qmtaha/",
  },
  {
    Name: "Mohammad Tashif",
    Company: "KPMG India",
  },
  {
    Name: "Yogesh Kumar",
    Img: "/assets/yogesh.jpeg",
    Post: "Grad student",
    Company: "U Alberta",
    linkedinurl: "https://www.linkedin.com/in/yogesh-kumar-amu",
  },
  {
    Name: "Rishabh",
    Company: "IIT Madras",
  },
  {
    Name: "Shivam Kumar Upadhyaya",
    Img: "/assets/shivam_upadhyaya.jpeg",
    Post: "Field System Engineer",
    Company: "Ather Energy",
    linkedinurl: "https://www.linkedin.com/in/shivam-kumar-upadhyaya/",
  },
  {
    Name: "Sarif Anwar",
    Img: "/assets/sarif.png",
    Company: "Stepping Cloud Consulting Private Limited",
    linkedinurl: "https://www.linkedin.com/in/sarif-anwar/",
  },
  {
    Name: "Shivam Kumar Upadhyaya",
    Img: "/assets/shivam_upadhyaya.jpeg",
    Post: "Field System Engineer",
    Company: "Ather Energy",
    linkedinurl: "https://www.linkedin.com/in/shivam-kumar-upadhyaya/",
  },
  {
    Name: "Mohammad Wamiq Hashmi",
    Company: "Ather Energy",
  },
  {
    Name: "Arpit Upadhyay",
    Img: "/assets/arpit.jpeg",
    Post: "Business Head D2C",
    Company: "The Man Company",
    linkedinurl: "https://www.linkedin.com/in/arpitupadhyay/",
  },
  {
    Name: "Abhishek Pathak",
    Img: "/assets/abhishek.png",
    Company: "Lucid Motors",
  },
  {
    Name: "Anant Agarwal",
    Company: "IIT Delhi",
    linkedinurl: "https://www.linkedin.com/in/anant-agarwal-3b3550212/",
  },
  {
    Name: "Arquam Hashim Siddiquie",
    Img: "/assets/arquam.jpg",
    Company: "L&T",
    linkedinurl:
      "https://www.linkedin.com/in/arquam-hashim-siddiquie-13b6b716b/",
  },
  {
    Name: "S. Nasir Asghar",
    Img: "/assets/nasir.jpeg",
    Post: "Mobility and R&D Engineer",
    Company: "Exicom Energy Systems",
    linkedinurl: "https://www.linkedin.com/in/syednasirasghar/",
  },
  {
    Name: "Syed Taimoor Ali",
    Img: "/assets/taimoor.jpg",
    Company: "EFS Global",
    linkedinurl: "https://www.linkedin.com/in/syed-taimoor-ali/",
  },
  {
    Name: "Ritik Prabhat",
    Img: "/assets/ritik_prabhat.jpg",
    Company: "Siemens",
    linkedinurl: "https://www.linkedin.com/in/ritik-prabhat-3357b420b/",
  },

  {
    Name: "Aditi Jaiswal",
    Img: "/assets/aditi.jpeg",
    Post: "MBA",
    Company: "University of Delhi",
    linkedinurl: "https://www.linkedin.com/in/aditi-jaiswal-4560a0172/",
  },
  {
    Name: "Areeb Mahmood",
    Img: "/assets/areeb.jpeg",
    Post: "Quality Engineer",
    Company: "Tesla",
    linkedinurl: "https://www.linkedin.com/in/areebmahmood/",
  },
  {
    Name: "Arpit Upadhyay",
    Img: "/assets/arpit.jpeg",
    Post: "Business Head D2C",
    Company: "The Man Company",
    linkedinurl: "https://www.linkedin.com/in/arpitupadhyay/",
  },
  {
    Name: "Arshil Ahmad",
    Img: "/assets/arshil.jpeg",
    Post: "Graduate Teaching Assistant",
    Company: "University of Regina",
    linkedinurl: "https://www.linkedin.com/in/arshil-ahmad-985b1322a/",
  },
  {
    Name: "Aman Agarwal ",
    Img: "/assets/aman.jpeg",
    Post: "Senior Product Marketing Specialist",
    Company: "Drawinbox",
    linkedinurl: "https://www.linkedin.com/in/amanagarwal95/",
  },
  {
    Name: "Anubha Agrawal",
    Img: "/assets/anubha.jpeg",
    Post: "Software Development Engineer",
    Company: "Amazon",
    linkedinurl: "https://www.linkedin.com/in/anubha-agrawal/",
  },
  {
    Name: "Ayush Gupta",
    Img: "/assets/ayush.jpeg",
    Post: "Design Release Engineer",
    Company: "Canoo, United States",
    linkedinurl: "https://www.linkedin.com/in/ayush19/",
  },

  {
    Name: "Azhar Eqbal",
    Img: "/assets/azhar.jpg",
    Post: "Senior Engineer",
    Company: "Tega Industries Limited",
    linkedinurl: "https://www.linkedin.com/in/azhar-eqbal-8198a2a5/",
  },
  {
    Name: "Dharmendra Pratap Singh ",
    Img: "/assets/dharmendra.jpeg",
    Post: "Data Scientist",
    Company: "Turing.com",
    linkedinurl: "https://www.linkedin.com/in/dharmendra-pratap-singh/",
  },
  {
    Name: "Gagan Garg ",
    Img: "/assets/gagan.jpeg",
    Post: "Head of Sales and Marketing",
    Company: "Garg International",
    linkedinurl: "https://www.linkedin.com/in/ggngrg/",
  },
  {
    Name: "Hamzah Khan",
    Img: "/assets/hamzah.jpeg",
    Post: "Head of DeFi and Labs",
    Company: "Polygon Technology",
    linkedinurl: "https://www.linkedin.com/in/hamzahkhan1/",
  },
  {
    Name: "Ibrahim Khan",
    Img: "/assets/ibrahim.jpeg",
    Post: "Data Scientist",
    Company: "Actify Data Labs",
    linkedinurl: "https://www.linkedin.com/in/khanibrahim123/",
  },
  {
    Name: "Irfan Khan",
    Img: "/assets/irfan.jpeg",
    Post: "Research Assistant",
    Company: "Politecnico di Torino",
    linkedinurl: "https://www.linkedin.com/in/irfan-khan-bb017b96/",
  },
  {
    Name: "Kashif Ahmad",
    Img: "/assets/kashif.jpeg",
    Post: "Industrial Engineer-IV",
    Company: "GEODIS",
    linkedinurl: "https://www.linkedin.com/in/kashifpurdue/",
  },
  {
    Name: "Md Burhan Shamsi",
    Img: "/assets/burhan.jpeg",
    Post: "Mechanical Design Engineer",
    Company: "Unbox Robotic",
    linkedinurl: "https://www.linkedin.com/in/md-burhan-shamsi-a182b6171/",
  },
  {
    Name: "Md Zeeshan Uddin",
    Img: "/assets/zeeshan.jpeg",
    Post: "Assistant Manager",
    Company: "CEAT Limited",
    linkedinurl: "https://www.linkedin.com/in/md-zeeshan-uddin-266807150/",
  },
  {
    Name: "Mirza Anas Beg",
    Img: "/assets/mirza.jpeg",
    Post: "Placement Coordinator",
    Company: "ZHCET, AMU",
    linkedinurl: "https://www.linkedin.com/in/mirza-anas-beg-88700b77/",
  },
  {
    Name: "Mohammad Afzal Shadab",
    Img: "",
    Post: "NASA Jet Propulsion Lab Graduate Fellow",
    Company: "NASA",
    linkedinurl: "https://www.linkedin.com/in/mafzalshadab/",
  },
  {
    Name: "Mohammad Faraz",
    Img: "/assets/faraz.jpeg",
    Post: "Software Developer",
    Company: "ETAS",
    linkedinurl: "https://www.linkedin.com/in/faraz-rwth/",
  },
  {
    Name: "Mohammed Tazeem",
    Img: "/assets/tazeem.jpeg",
    Post: "Graduate Enigneer Trainee",
    Company: "L&T Hydrocarbon Engineering Limited",
    linkedinurl: "https://www.linkedin.com/in/mohammed-tazeem-34b462189",
  },
  {
    Name: "Mohd Shareef Adil",
    Img: "/assets/shareef.jpeg",
    Post: "Software Developer - Data Analyst",
    Company: "e:fs TechHub, Germany",
    linkedinurl: "https://www.linkedin.com/in/mohd-shareef-adil/",
  },

  {
    Name: "Musfera Javed",
    Img: "/assets/musfera.jpeg",
    Post: "Decision Analytics Associate Consultant",
    Company: "ZS",
    linkedinurl: "https://www.linkedin.com/in/musfera-javed-65bb1185/",
  },
  {
    Name: "Owais Ahmed Khan",
    Img: "/assets/owais.jpeg",
    Post: "Lead Test Developer",
    Company: "Magna International",
    linkedinurl: "https://www.linkedin.com/in/owais-ahmed-khan-30a031108/",
  },
  {
    Name: "Pakhil Singh ",
    Img: "/assets/pakhil.jpeg",
    Post: "MS in Entrepreneurship by Research",
    Company: "IIT Madras",
    linkedinurl: "https://www.linkedin.com/in/pakhil-singh-1july/",
  },
  {
    Name: "Pradeep Kumar",
    Img: "/assets/pradeep.jpeg",
    Post: "Vehical Health Management Intern",
    Company: "General Motors, Michigan, USA",
    linkedinurl: "https://www.linkedin.com/in/pradeep-kumar-zhcet/",
  },
  {
    Name: "Prashant Vardhan Singh",
    Img: "/assets/prashant.jpeg",
    Post: "System Engineer",
    Company: "TCS",
    linkedinurl:
      "https://www.linkedin.com/in/prashant-vardhan-singh-a97619139/",
  },
  {
    Name: "Qazi Mohd Taha",
    Img: "/assets/qazi.jpeg",
    Post: "Digital Marketing Intern",
    Company: "Bright Money",
    linkedinurl: "https://www.linkedin.com/in/qmtaha/",
  },
  {
    Name: "Sharif Kidwai",
    Img: "/assets/sharif.jpeg",
    Post: "Hardware Product Engineer (MLB)",
    Company: "Apple, USA",
    linkedinurl: "https://www.linkedin.com/in/sharifkidwai/",
  },
  {
    Name: "Shivam Gupta",
    Img: "/assets/shivam.jpeg",
    Post: "Mtech (Electrical Engineering)",
    Company: "IIT Kanpur",
    linkedinurl: "https://www.linkedin.com/in/shivam-gupta-0756a5177/",
  },
  {
    Name: "Shivam Kumar Upadhyaya",
    Img: "/assets/shivam_upadhyaya.jpeg",
    Post: "Field System Engineer",
    Company: "Ather Energy",
    linkedinurl: "https://www.linkedin.com/in/shivam-kumar-upadhyaya/",
  },
  {
    Name: "S. Nasir Asghar",
    Img: "/assets/nasir.jpeg",
    Post: "Mobility and R&D Engineer",
    Company: "Exicom Energy Systems",
    linkedinurl: "https://www.linkedin.com/in/syednasirasghar/",
  },
  {
    Name: "Shubham Varshney",
    Img: "/assets/shubham.jpeg",
    Post: "Memory Design Engineer",
    Company: "STMicroelectronics",
    linkedinurl: "https://www.linkedin.com/in/shvarshney/",
  },

  {
    Name: "Syed Kashif Zafar",
    Img: "/assets/kashif.jpeg",
    Post: "Software Design Engineer",
    Company: "Alstom",
    linkedinurl: "https://www.linkedin.com/in/skashifzafar/",
  },
  {
    Name: "Somya Agarwal",
    Img: "/assets/somya.jpeg",
    Post: "Senior Business Analyst",
    Company: "Cognizant",
    linkedinurl: "https://www.linkedin.com/in/somya-agarwal-435205b6/",
  },
  {
    Name: "Vaibhav Sharma",
    Img: "/assets/vaibhav.jpeg",
    Post: "Machine Learning Engineer",
    Company: "ShareChat",
    linkedinurl: "https://www.linkedin.com/in/vaibhav-sharma-5a2a3b151/",
  },
  {
    Name: "Varun Bhardwaj",
    Img: "/assets/vaibhav.jpeg",
    Post: "Research Intern",
    Company: "Joint Institute of Nuclear Research",
    linkedinurl: "https://www.linkedin.com/in/varun-bhardwaj-mech",
  },
  {
    Name: "Vikram Parmar",
    Img: "/assets/vikram.jpeg",
    Post: "Teaching Assistent",
    Company: "IIT Delhi",
    linkedinurl: "https://www.linkedin.com/in/vikram-parmar-5a0933104",
  },
  {
    Name: "Waris Khan",
    Img: "/assets/waris.jpeg",
    Post: "Mechanical Design Engineer",
    Company: "DRONE POWER (P) LTD.",
    linkedinurl: "https://www.linkedin.com/in/waris-khan-a40110134/",
  },
  {
    Name: "Yogesh Kumar",
    Img: "/assets/yogesh.jpeg",
    Post: "Grad student",
    Company: "U Alberta",
    linkedinurl: "https://www.linkedin.com/in/yogesh-kumar-amu",
  },
  {
    Name: "Yogesh Upadhyay",
    Img: "/assets/yogesh_upadhyay.jpeg",
    Post: "Data Science & Business Analytics intern",
    Company: "Sparks Foundation",
    linkedinurl: "https://www.linkedin.com/in/sherbillyogeshupadhyay/",
  },
];
